import dayjs from 'dayjs'

import { ContractLanguage, TeacherContractStatus } from '~/types/teacher-contract'

export const STATUS_LABEL: Record<TeacherContractStatus, string> = {
  SENT: '待签署',
  SIGNED: '已签署',
  VOIDED: '已作废',
}

export const STATUS_COLOR: Record<TeacherContractStatus, string> = {
  SENT: 'gold',
  SIGNED: 'green',
  VOIDED: 'default',
}

export const LANGUAGE_LABEL: Record<ContractLanguage, string> = {
  EN: '英文',
  JA: '日文',
}

export const fmt = (ms?: number | null) => (ms ? dayjs(ms).format('YYYY-MM-DD HH:mm') : '-')

/** 写在模板编辑框旁边的格式说明（与 be-api ContractPdfRenderer 的标记一致） */
export const MARKUP_HELP = [
  '# 标题：居中加粗的合同标题；> 文字：标题下居中的一行（编号、日期）',
  '## 1. DEFINITIONS / ## 第1条（目的）：条款标题，加粗',
  '1.1 / 1 开头：条款编号（悬挂缩进）；(a) / (1) 开头：下一级的号，再缩进一级',
  '- 开头：列表项；--- 单独一行：分隔线；空行：段落间距',
  '**文字**：加粗（如定义词 "**Client**"）；其他每一行是两端对齐的段落',
  '{{变量名}}：发送时替换，例如 {{teacherName}}、{{fee}}',
]
